import {Component, Input, OnInit} from '@angular/core';
import {VoteWithProduct} from '@services/model/vote-with-product';
import {ProductStatus} from '@services/model/product';
import {Observable} from 'rxjs';
import {Cycle} from '@services/model/cycle';
import {CycleService} from '@services/cycle.service';
import {share} from 'rxjs/operators';
import {HpVoteWidgetComponent} from '@hp-dashboard/my-votes/hp-vote-widget/hp-vote-widget.component';
import {Option} from 'fp-ts/lib/Option';
import {CommonModule} from '@angular/common';
import {ProductListComponent} from '@app/product-list/product-list.component';
import {OptionPipe} from '@util/pipes/option-pipe';

@Component({
  selector: 'app-my-votes',
  templateUrl: './my-votes.component.html',
  styleUrls: ['./my-votes.component.scss'],
  standalone: true,
  imports: [CommonModule, ProductListComponent, OptionPipe, HpVoteWidgetComponent],
})
export class MyVotesComponent implements OnInit {
  ProductStatus = ProductStatus;

  cycle$: Observable<Option<Cycle>>;

  @Input() votes: VoteWithProduct[];

  constructor(private readonly cycleService: CycleService) {}

  ngOnInit() {
    this.cycle$ = this.cycleService.getCurrentVotingCycle().pipe(share());
  }
}
